import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Box, Stack, Container } from '@mui/material';

import { paths } from 'src/routes/routes/paths';

import { useResponsive } from 'src/hooks/use-responsive';

import { MetaHelmet } from 'src/layouts/Helmet/Helmet';
import { getAdvertiserProfile } from 'src/server/store/auth';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import AutomationCreate from 'src/sections/automation/curd/automationCreate';

function CreateAutomationPage() {
  const settings = useSettingsContext();
  const isMobile = useResponsive('down', 'sm');

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const credentialsYear = {
      enqueueSnackbar,
    };
    dispatch(getAdvertiserProfile(credentialsYear));
  }, [dispatch, enqueueSnackbar]);

  return (
    <>
      <MetaHelmet title="Create Automation " />
      <Container maxWidth={settings.themeStretch ? false : 'xl'}>
        <Box
          display={isMobile ? '' : 'flex'}
          alignItems="center"
          justifyContent={isMobile ? '' : 'space-between'}
          width="100%"
        >
          <Stack>
            <CustomBreadcrumbs
              heading="Create Automation "
              links={[
                {
                  name: 'Dashboard',
                  href: paths.dashboard.root,
                },
                {
                  name: 'Automation',
                  href: paths.dashboard.automation,
                },
                {
                  name: 'Create Automation ',
                },
              ]}
              sx={{
                mb: { xs: 3, md: 5 },
              }}
            />
          </Stack>
        </Box>
        <AutomationCreate />
      </Container>
    </>
  );
}

export default CreateAutomationPage;
